import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const isMainPage = location.pathname === '/';

    const handleFindMyBooking = () => {
        navigate('/find-booking');
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className="header">
            <div className="container">
                <nav className="nav">
                    <div className="nav-brand">
                        <Link to="/" className="nav-logo">
                            <img
                                src="/moveflair-logo.png"
                                alt="Moveflair Logo"
                                className="nav-logo-image"
                            />
                            <span className="nav-logo-text">Moveflair</span>
                        </Link>
                    </div>

                    <div className="nav-actions">
                        {isMainPage && (
                            <button
                                className="btn btn-outline btn-sm nav-booking-btn"
                                onClick={handleFindMyBooking}
                            >
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                                Manage Booking
                            </button>
                        )}

                        <button
                            className="nav-mobile-toggle"
                            onClick={toggleMobileMenu}
                            aria-label="Toggle mobile menu"
                        >
                            <svg className="nav-mobile-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {isMobileMenuOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>
                </nav>

                {/* Mobile Menu */}
                {isMobileMenuOpen && (
                    <div className="nav-mobile-menu">
                        {isMainPage && (
                            <button
                                className="btn btn-primary w-full"
                                onClick={() => {
                                    handleFindMyBooking();
                                    setIsMobileMenuOpen(false);
                                }}
                            >
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                                Manage Booking
                            </button>
                        )}
                        <div className="nav-mobile-links">
                            <Link
                                to="/faq"
                                className="nav-mobile-link"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                FAQ
                            </Link>
                            <a
                                href="mailto:info@moveflair.com"
                                className="nav-mobile-link"
                            >
                                Contact Us
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;